//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { IScheduledInstagramPost } from '@apis/universal-posts/scheduled-posts/universalScheduledPostsApiModel';
import { UniversalPostType } from '@apis/universal-posts/universalPostsApiModel';
import { getDateOfLatestPostImpl } from '@instagram-account/redux/schedule/export/selectors/getDateOfLatestPost';
import { getOrderedPosts } from '@instagram-account/redux/schedule/selectors/getOrderedPosts';
import DateString from '@models/DateString';
import { hasFullMediaAndNetworkItem } from '@models/IMlsMediaItem';
import TimeZoneId from '@models/TimeZoneId';
import { getUserTimeZone } from '@redux/selectors/getUserTimeZone';

export const getLatestFeedPreviewPostDateImpl = (
  orderedPosts: IScheduledInstagramPost[],
  tz: TimeZoneId,
) => {
  const filteredPosts = orderedPosts
    .filter(hasFullMediaAndNetworkItem)
    .filter(
      (post) =>
        post.postType === UniversalPostType.InstagramFeedAutomaticPost ||
        post.postType === UniversalPostType.InstagramFeedManualPost,
    );

  return getDateOfLatestPostImpl(filteredPosts, tz) ?? DateString.getToday(tz);
};

export const getLatestFeedPreviewPostDate = createSelector(
  getOrderedPosts,
  getUserTimeZone,
  getLatestFeedPreviewPostDateImpl,
);
